import { useState } from "react";
import { useNavigate } from "react-router";
import { Input } from "@/components/ds/Input/Input";
import { Button } from "@/components/ds/Button/Button";
import { getStoredGclid } from "@/analytics/gclid";
import styles from "./SignupForm.module.css";

interface SignupFormProps {
  readonly dark?: boolean;
  readonly ctaLabel?: string;
}

export function SignupForm({ dark, ctaLabel = "Try it free for 14 days" }: SignupFormProps) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    const trimmed = email.trim();

    if (!trimmed) {
      navigate("/signup");
      return;
    }

    setSubmitting(true);
    try {
      const gclid = getStoredGclid();
      await fetch("/api/lead-capture", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: trimmed, gclid }),
      });
    } finally {
      navigate(`/signup/password?email=${encodeURIComponent(trimmed)}`);
    }
  }

  return (
    <form onSubmit={handleSubmit} className={styles.form} id="signup">
      <div className={styles.fields}>
        <Input
          type="email"
          name="email"
          placeholder="you@cleaningco.co.uk"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          dark={dark}
          aria-label="Work email"
        />
      </div>
      <Button type="submit" size="lg" variant="accent" disabled={submitting}>
        {submitting ? "Starting…" : ctaLabel}
      </Button>
    </form>
  );
}
